import { useMemo } from "react";
import TextareaAutosize from "react-textarea-autosize";
import clsx from "clsx";

const ExpandableTextarea = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    error,
    touched,
    placeholder,
    className = "",
    minRows = 2,
    maxLength,
    showCounter = false,
    ...rest
}) => {
    const currentLength = value?.length ?? 0;

    const counterClassName = useMemo(() => {
        if (!showCounter || !maxLength) return "";
        const percent = (currentLength / maxLength) * 100;
        const colorClass = percent > 90 ? "text-orange-500" : "text-gray-500";
        return clsx("text-xs mt-1", colorClass);
    }, [showCounter, maxLength, currentLength]);

    return (
        <div className="w-full">
            {label && (
                <label
                    htmlFor={name}
                    className="block text-sm font-medium text-black mb-1"
                >
                    {label}
                </label>
            )}
            <TextareaAutosize
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                minRows={minRows}
                maxLength={maxLength}
                {...rest}
                className={clsx(
                    "w-full rounded-md p-2 placeholder-gray-500" +
                        "focus:border-gray-900 focus:ring-0 bg-transparent border-2 border-gray-400",
                    className,
                )}
            />
            {showCounter && maxLength && (
                <div className={counterClassName}>
                    {currentLength} / {maxLength} characters
                </div>
            )}
            {touched && error && (
                <div className="text-xs text-red-600 mt-1">{error}</div>
            )}
        </div>
    );
};

export default ExpandableTextarea;
